export default [
  {
    title: 'Sobre a Blipay',
    text: `Com a Blipay, você pode antecipar o seu salário para usar do jeito que quiser, sem preocupações e com muita flexibilidade.`,
  },
  {
    title: 'O que é o empréstimo de antecipação do salário?',
    text: `É uma modalidade que permite antecipar o valor do seu salário e usar da forma que quiser para pagar dívidas, contas ou realizar sonhos, sem precisar aguardar o depósito do salário na conta.`,
  },
  {
    title: 'Quais são as etapas de contratação?',
    text: `
      Após selecionar a sua oferta em nossa plataforma, você será direcionado para a contratação na plataforma da Blipay:
      <ul>
        <li>Realize o seu cadastro (nome, CPF, e-mail e telefone).</li>
        <li>Conecte a sua conta para análise do salário.</li>  
      </ul>
    `,
  },
  {
    title: 'Qual a documentação necessária para contratar?',
    text: `Não é necessário enviar seus documentos para a análise.`,
  },
  {
    title: `Qual a taxa de juros da Blipay?`,
    text: `A Blipay cobra uma taxa fixa sobre o valor antecipado a partir de 10%.`,
  },
  {
    title: `Quais são os requisitos para pedir o empréstimo?`,
    text: `Para solicitar um empréstimo na Blipay, é necessário receber uma renda, e qualquer modalidade de trabalho pode contratar, por exemplo, autônomos, aposentados, CLTs, entre outras, independentemente de estar com o nome sujo ou não.`,
  },
  {
    title: `Quanto tempo demora para saber se fui aprovado?`,
    text: `Você saberá se foi aprovado ou não no mesmo dia em que fizer o pedido do empréstimo.`,
  },
  {
    title: `Em quanto tempo vou receber o dinheiro na minha conta bancária?`,
    text: `Você receberá o dinheiro na sua conta de forma imediata via Pix.`,
  },
]
